import { useMarketplaceItemDetail } from '@/apis/marketplace/hooks/useMarketplaceItemDetails'
import { MarketplaceItem } from '@/apis/marketplace/marketplace.schema'
import MultiQueryPageLoader from '@/app/common/components/PageLoader/MultiQueryPageLoader'
import {
  addToCart,
  setCartAnimation,
  resetCartAnimation,
} from '@/storage/applications/marketplaceCartSlice'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ItemDetailUI } from '../components/ItemDetailUI'

const ItemDetailPage = () => {
  const [buttonAnimated, setButtonAnimated] = useState(false)


  // this is obviously not great. I need to fix this.
  const queryId = location.pathname.split('/')[2] ?? 0

  const itemId = parseInt(queryId)
  const query = useMarketplaceItemDetail(itemId)
  const navigate = useNavigate()
  const programSettings = useSelector(selectProgramSettings)

  const dispatch = useDispatch()

  useEffect(() => {
    if (programSettings.marketplace_module == 0) navigate(-1)
  }, [navigate])

  const handleAddToCart = (item: MarketplaceItem) => {
    dispatch(
      addToCart({
        quantity: 1,
        id: item.id,
        name: item.name,
        price: item.price,
      })
    )
    dispatch(setCartAnimation())
    setTimeout(() => dispatch(resetCartAnimation()), 500)

    setButtonAnimated(true)
    setTimeout(() => setButtonAnimated(false), 1000)
  }

  const goBack = () => {
    navigate(-1)
  }

  return (
    <MultiQueryPageLoader queries={[query] as const}>
      {([data]) => {
        return (
          <ItemDetailUI
            data={data}
            onGoBack={goBack}
            onAddToCart={handleAddToCart}
            buttonAnimated={buttonAnimated}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}

export default ItemDetailPage
